import React from "react";

function BookedCall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 54 54"
    >
      <path
        fill="#69bc45"
        d="M52.538 41.404c-1.898-3.587-8.899-7.69-8.899-7.69-1.584-.903-3.495-1.004-4.399.606 0 0-2.274 2.728-2.853 3.12-2.643 1.791-5.091 1.722-7.562-.75l-5.743-5.743-5.743-5.743c-2.472-2.472-2.541-4.919-.75-7.562.392-.579 3.12-2.853 3.12-2.853 1.609-.904 1.509-2.815.606-4.399 0 0-4.103-7.001-7.69-8.899a3.932 3.932 0 00-4.621.695L5.465 4.721C-2.58 12.766 1.381 21.85 9.426 29.895l7.353 7.353 7.353 7.353c8.045 8.045 17.129 12.007 25.174 3.961l2.537-2.537a3.935 3.935 0 00.695-4.621z"
        data-original="#69bc45"
      ></path>
      <path
        fill="#449e46"
        d="M53.421 40.937c-2.008-3.796-8.981-7.912-9.287-8.092-.896-.51-1.831-.78-2.706-.78-1.301 0-2.366.596-3.011 1.68-1.02 1.22-2.286 2.646-2.592 2.867-2.376 1.612-4.237 1.429-6.294-.629L18.044 24.496c-2.044-2.045-2.232-3.928-.632-6.29.224-.31 1.65-1.575 2.871-2.597.778-.463 1.312-1.15 1.545-1.995.312-1.122.082-2.444-.652-3.731-.173-.296-4.29-7.27-8.085-9.277a4.947 4.947 0 00-2.306-.573 4.904 4.904 0 00-3.489 1.445L4.758 4.015C.744 8.028-.709 12.577.437 17.535c.956 4.132 3.742 8.529 8.282 13.068l14.705 14.705c5.746 5.746 11.224 8.66 16.282 8.66h.001c3.72 0 7.188-1.581 10.305-4.698l2.537-2.537a4.907 4.907 0 00.872-5.796zm-2.286 4.381l-2.537 2.537c-2.729 2.729-5.72 4.112-8.891 4.112-4.509 0-9.512-2.717-14.869-8.074L10.133 29.188c-4.271-4.271-6.878-8.344-7.748-12.105-.995-4.3.244-8.112 3.786-11.654l2.537-2.537a2.92 2.92 0 012.076-.86c.476 0 .949.118 1.371.341 3.294 1.743 7.256 8.454 7.29 8.511.449.787.62 1.608.457 2.196-.1.36-.323.633-.683.835l-.151.104c-.853.711-2.882 2.433-3.308 3.061-.612.904-1.018 1.793-1.23 2.666-.711-1.418-1.286-3.061-1.475-4.881-.057-.548-.546-.931-1.098-.892a1.002 1.002 0 00-.892 1.099c.722 6.953 6.129 11.479 6.359 11.668.025.021.056.029.082.047l10.611 10.61c.044.044.09.083.134.126.036.053.059.111.106.157.189.187 4.704 4.567 11.599 5.283a1.001 1.001 0 00.206-1.99c-2.112-.219-3.983-.838-5.543-1.556.762-.231 1.538-.614 2.328-1.149.628-.425 2.35-2.455 3.061-3.308l.104-.151c.281-.5.712-.744 1.317-.744.52 0 1.129.185 1.705.512 1.879 1.102 7.072 4.559 8.521 7.296a2.919 2.919 0 01-.52 3.445z"
        data-original="#449e46"
      ></path>
      <circle
        cx="12"
        cy="39.968"
        r="12"
        fill="#e35c54"
        data-original="#556080"
      ></circle>
      <path
        fill="#fff"
        d="M18 38.968h-5v-5a1 1 0 00-2 0v5H6a1 1 0 000 2h5v5a1 1 0 002 0v-5h5a1 1 0 000-2z"
        data-original="#ffffff"
      ></path>
    </svg>
  );
}

export default BookedCall;
